export default __webpack_public_path__ + "static/ACaslonPro-Regular-becfcbfad21dba84d32e31b9af6d264f.ttf";